
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"-4 -4 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.188 14.25h-1.125a.562.562 0 00-.563.563v3.937H5.25V7.5h5.063a.562.562 0 00.562-.563V5.813a.563.563 0 00-.563-.562H4.689A1.687 1.687 0 003 6.938v12.375A1.687 1.687 0 004.688 21h12.375a1.687 1.687 0 001.687-1.688v-4.5a.562.562 0 00-.563-.562zM20.155 3h-4.5c-.751 0-1.127.91-.597 1.441l1.256 1.257-8.569 8.565a.843.843 0 000 1.195l.797.796a.843.843 0 001.195 0l8.565-8.567 1.256 1.254C20.086 9.47 21 9.1 21 8.344v-4.5A.844.844 0 0020.156 3z","fill":"#282E3E"}})])
          )
        }
      }
    